// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyApBnO69b1PR-ltB8EdAWk7j9x2wjLkBPw",
    authDomain: "iaxus-237407.firebaseapp.com",
    databaseURL: "https://iaxus-237407.firebaseio.com",
    projectId: "iaxus-237407",
    storageBucket: "iaxus-237407.appspot.com",
    messagingSenderId: "291402638461",
    appId: "1:291402638461:web:08e609a5f65809e3487d14",
    measurementId: "G-9X5W8GQMGT"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
